import { memo } from "react";
import type { FunctionComponent, ReactNode } from "react";

import { Portal } from "scmp-app/components/common/portal";
import { HeaderBottomContainerElementID } from "scmp-app/pages/_app/consts";

export type Props = {
  children?: ReactNode;
};

const HeaderBottom_: FunctionComponent<Props> = ({ children }) => (
  <Portal selector={`#${HeaderBottomContainerElementID}`}>{children}</Portal>
);

export const HeaderBottom = memo(HeaderBottom_);

HeaderBottom.displayName = "HeaderBottom";
